import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';

/**
 * Plain HTTP loader for ngx-translate. We roll our own (rather than use the
 * v17 {@code TranslateHttpLoader} helper) because the helper's constructor
 * uses {@code inject()} internally, which means it only works when registered
 * via the v17-specific {@code provideTranslateHttpLoader()} provider — and
 * that helper's interaction with {@code TranslateModule.forRoot()} /
 * {@code provideTranslateService()} is order-dependent in a way that left
 * the NoOp loader active on this app, and every key fell through as its
 * raw form.
 *
 * A constructor-injected loader sidesteps all of that: we control the
 * factory, we control the URL, we control the cache-bust. Plain Angular DI.
 */
export class HildaTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    // Cache-bust the bundle URL so an early-shipped empty placeholder can't be
    // served from the browser cache after the file has been filled in.
    const url = `/assets/i18n/${lang}.json?ts=${Date.now()}`;
    // console.log(this.http.get<TranslationObject>(url));
    return this.http.get<TranslationObject>(url);
  }
}

/** Factory used by the TranslateLoader provider in {@code app.config.ts}. */
export function hildaTranslateLoaderFactory(http: HttpClient): TranslateLoader {
  return new HildaTranslateLoader(http);
}
